<template>
  <div id="repair">
    <section class="sec1">
      <p class="p-h5">选择报事类型：</p>
      <div class="selective-type">
        <div class="public">
          <img @click="typea()" v-show="this.ispuba" src="../../../../static/img/public-area.png">
          <img @click="typea()" v-show="!this.ispuba" src="../../../../static/img/public-area-no.png">
          <p :class="this.ispuba ? 'span-2' :'span-1'">公区报修</p>
        </div>
        <div class="residential">
          <img @click="typeb()" v-show="this.ispubb" src="../../../../static/img/residential.png">
          <img @click="typeb()" v-show="!this.ispubb" src="../../../../static/img/residential-no.png">
          <p :class="this.ispubb ? 'span-2' :'span-1'">住宅报修</p>
        </div>
      </div>
    </section>
    <section class="sec2">
      <p class="p-h5">事件内容：</p>
      <div>
        <textarea maxlength="100" id="content" autofocus v-model="repairContent" cols="50" rows="5" placeholder="请描述问题内容"></textarea>
      </div>
    </section>
    <section class="sec3">
      <p class="p-h5">添加照片：</p>
      <div>
        <ul>
          <li v-for="(src,index) in files" :key="index">
            <img class='preview' :src="src">
            <img class="close" @click="close(index)" src="../../../../static/img/closea.png">
          </li>
          <li>
            <input type='file' name="doc" ref="choose" accept="image/*" id="doc"  @change='setImagePreview($event)' hidden/>
            <img class="add-baoxiu" @click="chooseImg" v-if="this.files.length<4" src="../../../../static/img/add-baoxiu.png">
          </li>
        </ul>
      </div>
    </section>
    <section class="sec4">
      <p class="p-h5">详细位置</p>
      <div>
        <oSelect @changeOption="onChangeOption"  :selectData="selectData"></oSelect>
      </div>
    </section>
    <footer class="sec5">
      <input type="button" class="btn" @click="btn" value="我要上报" :disabled="isDisable">
    </footer>
    <img id='loading' src="../../../../static/img/loading2.gif"  v-if="isDisplay"  />
  </div>
</template>
<script>
  import oSelect from '../../Son/select.vue'//引入子组件

	export default{
    name:"repair",
    components: {
      'oSelect':oSelect, //注册组件
    },
    data () {
      return {
        files:[],   //报修图片的src
        file: [],   //报修图片
        repairContent: '',   //报修内容
        ispuba:false,    //是否公区
        ispubb:false,
        id:sessionStorage.getItem('el'),//房屋名称
        houseid:sessionStorage.getItem('houseid'),//房屋id
        isclicked:0,
        cilck_btn:false,
        showImg:false,
        selectData:{
          defaultIndex:0,//默认选中是第几个
          selectStatus:false,//通过这个来控制下拉框的显示和隐藏
          selectOptions:[]//下拉框中的参数
        },
        isDisable:false,
        isDisplay:false//默认不显示loading图
      }
    },
    mounted () {
      const _this = this
      if (_this.$route.params.house) {
        _this.selectData.selectOptions = _this.$route.params.house
      }
      else {
        _this.postRequest('house/queryByUserId', {}, function (data) {
          _this.selectData.selectOptions = data
        })
      }
        _this.files=[]
        _this.ispuba=true
        _this.ispubb=false
        _this.repairContent=''
        _this.isclicked=0
    },
    methods: {
      onChangeOption(index,id){//选择下拉的列表
        this.selectData.defaultIndex=index
        this.houseid = id
      },
      viewImg(){
        this.showImg = false;
      },
      typea (){
        this.ispuba = true
        this.ispubb = false
      },
      typeb () {
        this.ispubb = true
        this.ispuba = false
      },
      btn () {
        let formData = new FormData();
        for(let i=0;i<this.file.length;i++){
          formData.append('files',this.file[i])
          console.log(this.file[i])
        }
        formData.append('content',this.repairContent)
        formData.append('type',1)
        formData.append('isPub',this.ispuba)
        formData.append('houseId',this.houseid)
        sessionStorage.setItem('tousu','0')
      	if(!this.isDisable){
		        if(!this.repairContent){
		          alert('请填写信息')
		        }else{
		          if(!this.click_btn){
		          	//显示loading图
		          	this.isDisplay=true
		            this.uploadFileRequest('wo/add', formData)
		              .then(res => {
		                if(res.data.code === 200 ){
		                	//将按钮设置为可用状态，相同的内容不可重复上报
		                	this.isDisable=false
		                	//隐藏loading图
		                	this.isDisplay=false
		                alert('报修成功')
		                this.$router.push({name:'complainList'})
		                }else if(res.data.code===406){
                      //隐藏loading图
                      this.isDisplay=false
		                  alert(res.data.message)
		                }
		              }).catch( res => {})
		          }
		          this.click_btn = true
		        }
      	}else{
      		alert('请勿频繁点击')
      	}
      },
      chooseImg () {
        this.$refs.choose.click()
      },
      setImagePreview (event) {
        this.file.push(event.target.files[0])
        this.files.push(window.URL.createObjectURL(event.target.files[0]))
        let filess = event.target.files || event.dataTransfer.files
        if (this.files.length === 0) return;
        this.createImage (filess,event)
      },
      createImage (file, event) {
        let _this = this
        this.lrz(file[0],{
          width:100,
          quality:.5
        }).then(function(rst) {
          _this.file.push(rst.base64)
          return rst;
        }).always(function() {
          event.target.value = null;
        })
      },
      close (val) {
        this.files.splice(val,1)
      }
  }
}
</script>
<style scoped>
  /*点击上报的时候 显示 loading*/
  #loading{
    position:fixed;
    left:47%;
    top:40%;
    transform: translateY(-50%),translateX(-50%);
  }
#repair{
  text-align: left;
  padding: 0 26px;
  box-sizing: border-box;
}
section{
  border-bottom: 1px solid #ECECEC;
  margin-bottom: 28px;
}
.p-h5{
  font-size:34px;
  color:#000;
  margin: 33px 0;
}
.selective-type{
  display: flex;
  justify-content:space-around;
  margin-bottom:56px;
}
.selective-type .public{
  margin-left: 70px;
}
.selective-type .residential{
  margin-right: 70px;
}
.selective-type img{
  width: 84px;
  height: 85px;
  margin: 0 0 34px 18px;
}
.span-1{
  color:#ccc;
  font-size:30px;
}
.span-2{
  color:#F7B932;
  font-size:30px;
}
textarea::-webkit-input-placeholder{ /*WebKit browsers*/
  color: #ccc;
}
.sec2 div textarea{
  width:700px;
  height:210px;
  padding: 19px;
  background: #f6f6f6;
  box-sizing: border-box;
  font-size:24px;
  margin-bottom: 38px;
  border-radius:10px;
  box-shadow:4px 2px 6px rgba(228,228,228,0.18);
}
.sec3 ul{
  margin-bottom: 36px;
  display: flex;
  justify-content:left;
}
.add-baoxiu{
  width: 120px;
  height: 120px;
}
.preview{
  width: 130px;
  height: 130px;
}
.close{
  width: 35px;
  height: 35px;
  position: relative;
  top: -114px;
  left: -26px;
}
.sec5{
  text-align: center;
}
.btn{
  margin: 104px 0 60px 0;
  width: 520px;
  height: 80px;
  border-radius: 40px;
  /*background: -webkit-linear-gradient(left, #FFA650,#F7B932); !* Safari 5.1 - 6.0 *!*/
  /*background: -o-linear-gradient(right,  #FFA650,#F7B932); !* Opera 11.1 - 12.0 *!*/
  /*background: -moz-linear-gradient(right, #FFA650,#F7B932); !* Firefox 3.6 - 15 *!*/
  /*background: linear-gradient(to right,  #FFA650,#F7B932); !* 标准的语法 *!*/
  background: #D70B19 ;
  font-size: 32px;
  color:#fff;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/repair/repair.vue